export enum ObjectType {
  AccessGroup = 'AccessGroup',
  SystemClassifier = 'SystemClassifier',
  Classifier = 'Classifier',
  ClassifierMapping = 'ClassifierMapping',
  DataObjectDescriptionVersion = 'DataObjectDescriptionVersion',
  DataObjectGroup = 'DataObjectGroup',
  DataSubject = 'DataSubject',
  InputDataGroup = 'InputDataGroup',
  InputDataDescription = 'InputDataDescription',
  User = 'User',
  Sample = 'Sample',
  Role = 'Role',
}
